var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'backbone', 'app-common/template/form/binary-toggle.htm'], function($, _, Backbone, template) {
  var BinaryToggleView;
  return BinaryToggleView = (function(_super) {

    __extends(BinaryToggleView, _super);

    function BinaryToggleView() {
      BinaryToggleView.__super__.constructor.apply(this, arguments);
    }

    BinaryToggleView.prototype.className = 'binarytoggle';

    BinaryToggleView.prototype.events = {
      'click input': 'toggleClicked'
    };

    BinaryToggleView.prototype.initialize = function(name, id, clazz, list, selectedValue, fields, defaultValue) {
      this.name = name != null ? name : null;
      this.id = id != null ? id : _.uniqueId('binary_toggle');
      this.clazz = clazz != null ? clazz : null;
      this.list = list != null ? list : [
        {
          name: 'ON',
          value: true
        }, {
          name: 'OFF',
          value: false
        }
      ];
      this.selectedValue = selectedValue != null ? selectedValue : null;
      this.fields = fields != null ? fields : {
        name: 'name',
        value: 'value'
      };
      this.defaultValue = defaultValue != null ? defaultValue : null;
      BinaryToggleView.__super__.initialize.apply(this, arguments);
      this.attributes = {
        name: this.name,
        "class": this.clazz
      };
      if (this.selectedValue == null) {
        this.selectedValue = this.list[0][this.fields.value];
      }
      if (this.defaultValue == null) {
        this.defaultValue = this.selectedValue;
      }
      this.selectedValue = this.defaultValue;
      return this.value = this.selectedValue;
    };

    BinaryToggleView.prototype.render = function() {
      var checked;
      checked = false;
      if (this.list[0][this.fields.value] === this.selectedValue) {
        checked = true;
      }
      this.$el.html(_.template(template, {
        clazz: this.clazz,
        name: this.name,
        id: this.id,
        before: this.list[0][this.fields.name],
        after: this.list[1][this.fields.name],
        isChecked: checked
      }));
      return this;
    };

    BinaryToggleView.prototype.reset = function() {
      if (this.value !== this.defaultValue) {
        return this.$el.find("input").triger('clicked');
      }
    };

    BinaryToggleView.prototype.clear = function() {
      if (this.value !== this.selectedValue) {
        return this.$el.find("input").triger('clicked');
      }
    };

    BinaryToggleView.prototype.val = function() {
      return this.value;
    };

    BinaryToggleView.prototype.toggleClicked = function() {
      var otherObj,
        _this = this;
      otherObj = _.omit(this.list, function(obj) {
        return obj[_this.fields.value] === _this.value;
      });
      return this.value = otherObj[this.fields.value];
    };

    return BinaryToggleView;

  })(Backbone.View);
});
